import contracts from '../constants/web3.contracts';

export function findContractByAssetCode(assetCode?: string) {
  return contracts.find((el) => el.id === assetCode);
}

export function shortenAddress(address = '', chars = 4): string {
  if (!address) return '';
  return `${address.slice(0, 2 + chars)}...${address.slice(-chars)}`;
}
